module.exports = __webpack_public_path__ + "arrow_silver_left.png?f51e210170dc17c4d3956eaaeaca3f52";


//////////////////
// WEBPACK FOOTER
// ./assets/img/arrow_silver_left.png
// module id = 35
// module chunks = 0